import { render } from "./StreakProgressBarComponent.vue?vue&type=template&id=bf3b30e2&ts=true"
import script from "./StreakProgressBarComponent.vue?vue&type=script&lang=ts"
export * from "./StreakProgressBarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__